import React, { Fragment } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, TitleComponent, LegendComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import NoRow from '@/components/DataTable/CustomNoRow';


echarts.use(
  [TitleComponent, LegendComponent, TooltipComponent, GridComponent, PieChart, CanvasRenderer]
);

class InstrumentECharts extends React.Component {
  constructor(props) {
    super(props);
    props.innerRef(this);
    const textColor = this.props.theme === 'light' ? '#000' : '#fff'
    this.state = {
      option: {
        tooltip: {
          trigger: 'item',
          confine:true,
        },
        // legend: {
        //   bottom: '5%',
        //   left: 'center',
        //   data: [{
        //     name: this.props.language.market_bull_ultra_block,
        //     textStyle: {
        //       color: textColor
        //     }
        //   }, {
        //     name: this.props.language.market_bear_ultra_block,
        //     textStyle: {
        //       color: textColor
        //     }
        //   }]
        // },
        series: [
          {
            name: this.props.language.market_distribution_title,
            type: 'pie',
            radius: ['30%', '45%'],
            itemStyle: {
              normal: {
                color: this.colorArr
              }
            },
            label: {
              formatter: '{d}%',
              color: textColor
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.props.data
          }
        ]
      },
      index: 0,
      myChart: null,
      bullBgColor: [],
      bearBgColor: [],
      sumBearBgColor:null,
      sumBullBgColor:null,
    }
  }

  colorArr = (seriesIndex) => {
    return seriesIndex.data.bgColor
  }

  unique(arr) {
    return arr.filter(function (item, index, arr) {
      return arr.indexOf(item, 0) === index;
    });
  }

  setEChartPieData = (data) => {
    if (this.echartsElementRef) {
      this.echartsElementRef.getEchartsInstance().setOption(data, false, true);
    }
  }

  componentDidUpdate(prevProps) {
    if ((this.props.theme !== prevProps.theme) || (prevProps.language.lang !== this.props.language.lang)) {
      const textColor = this.props.theme === 'light' ? '#000' : '#fff'
      const deepOption = JSON.parse(JSON.stringify(this.state.option))
      deepOption.series[0].label.color = textColor
      this.setState({ option: deepOption })
    }
    if ((prevProps.language.lang !== this.props.language.lang) || (this.props.data != prevProps.data) ) {
      this.setState({ bearBgColor: [], bullBgColor: [] })
    }
  }

  render() {
    const { language, data ,isMobile } = this.props;
    return (
      <div className="instrument-pie-chart">
        <div className="title">
          <span>{language.market_distribution_title}</span>
          <span style={{fontSize:isMobile && '14px',color:isMobile && '#aaafb6'}} >{language.market_distribution_unit}</span>
        </div>
        {Array.isArray(data) && data.length && <ReactEChartsCore
          ref={e => this.echartsElementRef = e}
          echarts={echarts}
          option={this.state.option}
          theme={"theme_name"}
        /> || <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' ,minHeight:'300px', width :'100%'}} /> }
        {/* <div className="no-data-container">{language.common_no_data}</div> */}
      </div>
    )
  }
}

InstrumentECharts.defaultProps = {
  data: []
}

export default connect(
  (state) => ({
    language: state.app.language,
    theme: state.app.theme,
    currentTradingAccount: state.trade.currentTradingAccount,
    isMobile: state.app.isMobile,
  }),
  (dispatch) => ({

  })
)(InstrumentECharts);
